import { render, staticRenderFns } from "./ProductImageCopier.vue?vue&type=template&id=aa582836"
import script from "./ProductImageCopier.vue?vue&type=script&lang=js"
export * from "./ProductImageCopier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports